<div id="main-wrapper">
  <div id="content-wrapper">
    <router-outlet (activate)="userLoggedIn = this.checkIfUserIsLoggedIn()"></router-outlet>
    <app-feedback-button *ngIf="userLoggedIn && demoGithubButtonHidden()"></app-feedback-button>
  </div>
  <ng-container *ngIf="isPlayground" id="footer-wrapper">
    <app-demo-footer></app-demo-footer>
  </ng-container>
</div>
